import Exhibitor from "./interfaces/_Exhibitor";

export const FPS = 60;
export const IS_DEBUG = false;
export const NEWS_LIST_LIMIT = 10;
export const HOME_NEWS_LIST_LIMIT = 4;
export const EXHIBITOR_LIST_LIMIT = 999; // ページングしない

export const PAGINATION_NEIGHBOR_COUNT = 3;

// 1000日前
export const COUNTDOWN_1000DAYS_TEXT = "2022-07-18T00:00:00.000+09:00";
// 日本標準時の開催日0時0分0秒
export const COUNTDOWN_TO_TEXT = "2025-04-13T00:00:00.000+09:00";

export const THEME_LIST = ["reborn01", "reborn02", "reborn03"];

interface ExhibitorCompanyOverview {
  field: keyof Exhibitor,
  header: string;
}
export const EXHIBITOR_COMPANY_OVERVIEW_LIST: ExhibitorCompanyOverview[] = [
  {
    field: "companyFounded",
    header: "設立",
  },
  {
    field: "companyLocation",
    header: "所在地",
  },
  {
    field: "companyRep",
    header: "代表者",
  },
  {
    field: "companyEmployees",
    header: "従業員数",
  },
  {
    field: "companyCapital",
    header: "資本金",
  },
  {
    field: "companyMainBusiness",
    header: "主な事業",
  },
];
